import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import {
  FiAlignRight,
  FiXCircle,
  FiChevronDown,
  FiChevronRight,
} from "react-icons/fi";
import "./LTTPodcastContent.css";
import LTTPodcastNavbarmenu from "./LTTPodcastNavbarmenu";
import PodcastSideNavbar from "./PodcastSideNavbar";
import AOS from "aos";
import "aos/dist/aos.css";
import FeaturedEpisodeSection from "./FeaturedEpisodeSection";

function LTTPodcastContent() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  return (
    <>
      <div className="navbar-holder podcast-navbar-holder">
        <LTTPodcastNavbarmenu />
      </div>
      <div className="podcast-sidenavbar-holder">
        <PodcastSideNavbar />
      </div>
      <div className="video-container" id="main">
        <title>L-TT Podcast</title>
        {/* <h1 class="sr-only" tabIndex={0}>
          LTT-Podcast
        </h1> */}
        <img
          src={
            process.env.PUBLIC_URL + "/images/Banners/Podcast-banner-mobile.png"
          }
          alt="home-banner"
          className="banner-img mobile-banner"
        />
        <img
          src={process.env.PUBLIC_URL + "/images/Banners/Podcast-banner.png"}
          alt="podcast-banner"
          className="banner-img desktop-banner"
        />
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/LTT-Podcast"
            >
              L&TT Podcast
            </NavLink>
          </li>
        </ul>
        <div className="all-headings-text-box">
          <h1 tabIndex={0}>L&TT Unplugged</h1>
          <p>Connecting the connected...</p>
          <p>
            Plug into a treasure trove of captivating conversations and stories.
            Unlock limitless possibilities through meaningful conversations,
            learning, and inspiration as we delve into the realms of the
            brightest minds, like-minded peers, and thought leaders.
          </p>
        </div>
        {/* <p data-aos="fade-up">
          Plug into a treasure trove of captivating conversations and stories.
          Unlock limitless possibilities through meaningful conversations,
          learning, and inspiration as we delve into the realms of the brightest
          minds, like-minded peers, and thought leaders.
        </p> */}
      </div>
      {/* first section */}
      <div className="podcast-leader-msg-container">
        <div className="podcast-leader-msg-wrap">
          <div className="podcast-leader-msg-row row2" data-aos="fade-right">
            <div className="podcast-leader-msg-box">
              <img
                src={
                  process.env.PUBLIC_URL + "/images/Podcast/AmbrishRastogi.png"
                }
                alt="Leadership"
                className="leadership-img"
              />
            </div>
          </div>
          <div className="podcast-leader-msg-row row1" data-aos="fade-left">
            <div className="podcast-leader-msg-box">
              <p className="description">
                Tune in to L&TT Unplugged, a podcast that champions continuous
                learning and keeps you ahead in today's tech-driven world. Dive
                into insightful episodes and embark on your journey to becoming
                your best self!
              </p>
              <h3 className="title">Ambrish Rastogi</h3>
              {/* <p className="designation">
                Lead - Learning & Leadership Development, ATC-GN
              </p> */}
              <p className="designation">
                Managing Director, Lead - Learning and Talent Transformation Advanced Technology Centers in India
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* second section */}
      <div className="featured-episode-container" id="Library">
        <div className="featured-episode-wrap">
          <div className="heading-box">
            <h2 className="main-headings">Featured Episode</h2>
          </div>
          <div className="featured-episode-extra-wrap">
            <FeaturedEpisodeSection />
          </div>
        </div>
      </div>
    </>
  );
}

export default LTTPodcastContent;
